module.exports = __webpack_public_path__ + "img/leeb-balkone-mitarbeiter-4.9e1203a3.jpeg";